import React, { useMemo } from 'react';

import { IntegrationDomain } from 'api/usePublisherIntegrationTest';

import { IntegrationTestModal } from 'components/IntegrationTestModal/IntegrationTestModal';

import { IIntegrationSectionDependencies } from '../DeveloperSettings.integration';
import { ESavingForm } from '../DeveloperSettings.types';
import { buildGrantAwardVersionConfigs } from '../helpers/versionConfigs.helpers';
import { useGrantAwardForm } from '../hooks/useCallbackForms';
import { useGrantAwardTestModal } from '../hooks/useGrantAwardTestModal';
import { useIntegrationTestModal } from '../hooks/useIntegrationTestModal';

import { CallbackSection } from './CallbackSection';

interface IGrantAwardSectionProps extends IIntegrationSectionDependencies {
  isAwardingV2FeatureFlagOn: boolean;
}

export const GrantAwardSection: React.FC<IGrantAwardSectionProps> = ({
  publisherId,
  integrationData,
  updateIntegration,
  getIntegration,
  savingForm,
  setSavingForm,
  isProfilesEnabled,
  hasCategories,
  isWebStore,
  isWebCheckout,
  setTaskStatus,
  isAwardingV2FeatureFlagOn
}) => {
  const form = useGrantAwardForm({
    integrationData,
    updateIntegration,
    getIntegration,
    hasCategories,
    isWebStore,
    isWebCheckout,
    setTaskStatus,
    setSavingForm
  });

  const testModalData = useGrantAwardTestModal({
    grantAwardForm: form,
    isAwardingV2FeatureFlagOn
  });

  const testModal = useIntegrationTestModal({
    publisherId,
    domain: IntegrationDomain.AWARD,
    version: testModalData.version,
    title: 'Grant Award Callback Test',
    callbackUrl: testModalData.callbackUrl
  });

  const versionConfigs = useMemo(
    () => buildGrantAwardVersionConfigs(form, isAwardingV2FeatureFlagOn),
    [form, isAwardingV2FeatureFlagOn]
  );

  const { schema, ...testModalProps } = testModal;

  return (
    <>
      <CallbackSection
        title="Grant Award Callback"
        versionConfigs={versionConfigs}
        onSave={form.submitForm}
        isSaveDisabled={!form.dirty || savingForm !== ESavingForm.NONE}
        isLoading={savingForm === ESavingForm.GRANT_AWARD}
        disabled={isProfilesEnabled}
        onTestClick={testModal.openModal}
        testButtonDisabled={!testModalData.callbackUrl}
      />
      {schema && (
        <IntegrationTestModal
          {...testModalProps}
          schema={schema}
          schemaSelectorLabel="Order Type"
        />
      )}
    </>
  );
};
